import React, { Component } from "react";
import RootRoute from "./routes";
import initReactFastClick from "react-fastclick"
import EnvironmentSelector from './environments/Selector';

class App extends Component {
  compponentWillMount() {
    initReactFastClick();
  }

  render() {
    return (
      <div className="app-container">
        <EnvironmentSelector>
          <RootRoute />
        </EnvironmentSelector>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js